import { getOffset } from '../../Utils/utils'
export const engagementScroll = () => {
  const engagementLinks = document.querySelectorAll('.list_engagement_component a.col_item')
  const contentSections = document.querySelectorAll('.text_visuel_cta_two_col_component')
  const headerHeight = document.querySelector('header .header_fix').offsetHeight

  if (engagementLinks?.length && contentSections?.length && engagementLinks?.length === contentSections?.length) {
    engagementLinks.forEach((link, index) => {
      link.addEventListener('click', (e) => {
        e.preventDefault()
        window.scrollTo({
          top: getOffset(contentSections[index]).top - headerHeight - 100,
          behavior: 'smooth'
        })
      })
    })
  }
}
